import script from "./MoneyInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MoneyInput.vue?vue&type=script&setup=true&lang=js"

import "./MoneyInput.vue?vue&type=style&index=0&id=13768f94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13768f94"]])

export default __exports__